import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import theme from './theme';
import PrivateRoute from './PrivateRoute';
import { tomarEmpresaDeLaDireccion } from './empresa';
import OrdenesServicio from './components/OrdenesServicio';
import Sedes from './components/Sedes';
import Conceptos from './components/Conceptos';
import Servicios from './components/Servicios';
import TiposOrden from './components/TiposOrden';
import Maestros from './components/Maestros';
import Auditoria from './components/Auditoria';
import Usuarios from './components/Usuarios';
import { SedeProvider } from './contexto/Sede';
import { PeriodoProvider } from './contexto/Periodo';
import Layout from './components/Layout';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Terceros from './components/Terceros';
import Facturas from './components/Facturas';
import FacturaDetalle from './components/FacturaDetalle';
import Pagos from './components/Pagos';
import Cartera from './components/Cartera';
import Configuracion from './components/Configuracion';
import PlanCuentas from './components/PlanCuentas';
import LibroDiario from './components/LibroDiario';
import ReportesFinancieros from './components/ReportesFinancieros';
import Egresos from './components/Egresos';

const isTestEnv = process.env.REACT_APP_ENV === 'test';


// El hub abre erp.nara.chat/?empresa=<id> (DA-16): se toma antes del primer pedido.
tomarEmpresaDeLaDireccion();

/** Todo lo que exige sesión: primero autenticación, luego la sede activa
 *  —que solo se consulta con sesión— y por último el marco de la aplicación. */
function Privado({ children }) {
  return (
    <PrivateRoute>
      <SedeProvider>
        <PeriodoProvider>
          <Layout>{children}</Layout>
        </PeriodoProvider>
      </SedeProvider>
    </PrivateRoute>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isTestEnv && (
        <Box sx={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
          bgcolor: '#dc2626', color: '#fff', py: 0.5,
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
          boxShadow: '0 2px 8px rgba(220, 38, 38, 0.4)',
        }}>
          <WarningAmberIcon sx={{ fontSize: 16 }} />
          <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.5 }}>
            AMBIENTE DE PRUEBA — Los datos aqui NO son reales
          </Typography>
        </Box>
      )}
      <BrowserRouter>
        <Routes>
          {/* Login queda FUERA del proveedor de sede: no hay sesión todavía
              y pedir datos ahí dispara el 401 que recarga. */}
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Privado><Dashboard /></Privado>} />
          <Route path="/terceros" element={<Privado><Terceros /></Privado>} />
          <Route path="/ordenes" element={<Privado><OrdenesServicio /></Privado>} />
          <Route path="/sedes" element={<Privado><Sedes /></Privado>} />
          <Route path="/conceptos" element={<Privado><Conceptos /></Privado>} />
          <Route path="/servicios" element={<Privado><Servicios /></Privado>} />
          <Route path="/tipos-orden" element={<Privado><TiposOrden /></Privado>} />
          <Route path="/maestros" element={<Privado><Maestros /></Privado>} />
          <Route path="/usuarios" element={<Privado><Usuarios /></Privado>} />
          <Route path="/auditoria" element={<Privado><Auditoria /></Privado>} />
          <Route path="/facturas" element={<Privado><Facturas /></Privado>} />
          <Route path="/facturas/:id" element={<Privado><FacturaDetalle /></Privado>} />
          <Route path="/pagos" element={<Privado><Pagos /></Privado>} />
          <Route path="/cartera" element={<Privado><Cartera /></Privado>} />
          <Route path="/egresos" element={<Privado><Egresos /></Privado>} />
          <Route path="/contabilidad/cuentas" element={<Privado><PlanCuentas /></Privado>} />
          <Route path="/contabilidad/diario" element={<Privado><LibroDiario /></Privado>} />
          <Route path="/contabilidad/reportes" element={<Privado><ReportesFinancieros /></Privado>} />
          <Route path="/configuracion" element={<Privado><Configuracion /></Privado>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
